module.exports = __webpack_public_path__ + "img/witness.bb8af7ec.svg";